import './advertise/billing_logs.scss'
import 'flatpickr/dist/flatpickr.min.css'

const PAL = ['#5b4fcf','#0d9488','#d97706','#ef4444','#06b6d4','#8b5cf6','#ec4899']

document.addEventListener('DOMContentLoaded', init)
document.addEventListener('turbo:load',       init)
document.addEventListener('turbolinks:load',  init)

function init() {
  initDatePicker()
  initBillingLineChart()
  initDisplaysBarChart()
  initBillingTable()
}

/* ── Date range picker ── */
function initDatePicker() {
  var btn    = document.getElementById('blDateBtn')
  var picker = document.getElementById('blDatePicker')
  var form   = document.getElementById('blDateForm')
  var startI = document.getElementById('blStartDate')
  var endI   = document.getElementById('blEndDate')
  var label  = document.getElementById('blDateLabel')
  if (!btn || !picker || !form) return

  var fp = flatpickr(picker, {
    mode: 'range',
    dateFormat: 'Y-m-d',
    defaultDate: [btn.dataset.start, btn.dataset.end],
    maxDate: 'today',
    showMonths: 2,
    disableMobile: true,
    clickOpens: false,
    positionElement: btn,
    onChange: function(dates) {
      if (dates.length !== 2) return
      var fmt = function(d) {
        return d.getFullYear() + '-' +
          String(d.getMonth()+1).padStart(2,'0') + '-' +
          String(d.getDate()).padStart(2,'0')
      }
      startI.value = fmt(dates[0])
      endI.value   = fmt(dates[1])
      var M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
      var s = dates[0], e = dates[1]
      if (label) {
        label.textContent = s.getMonth() === e.getMonth() && s.getFullYear() === e.getFullYear()
          ? M[s.getMonth()] + ' ' + s.getDate() + '–' + e.getDate() + ', ' + e.getFullYear()
          : M[s.getMonth()] + ' ' + s.getDate() + ', ' + s.getFullYear() + ' – ' +
            M[e.getMonth()] + ' ' + e.getDate() + ', ' + e.getFullYear()
      }
      form.submit()
    }
  })
  btn.addEventListener('click', function() { fp.open() })
}

/* ── Billing trend — LINE chart (distinct from dashboard bar) ── */
function initBillingLineChart() {
  var el = document.getElementById('billing_chart')
  if (!el) return
  if (el._chartInstance) { el._chartInstance.destroy(); el._chartInstance = null }

  var labels = JSON.parse(el.dataset.key)
  var values = JSON.parse(el.dataset.data).map(Number)
  var avg    = values.length ? values.reduce(function(a,b){return a+b},0) / values.length : 0

  el._chartInstance = new Chart(el, {
    type: 'line',
    data: {
      labels: labels,
      datasets: [
        {
          label: 'Billing (₹)',
          data: values,
          borderColor: '#5b4fcf',
          backgroundColor: 'rgba(91,79,207,0.08)',
          borderWidth: 2.5,
          pointRadius: 3,
          pointBackgroundColor: '#5b4fcf',
          fill: true,
          tension: 0.35
        },
        {
          label: 'Avg',
          data: values.map(function() { return Math.round(avg) }),
          borderColor: '#c4b5fd',
          borderWidth: 2,
          borderDash: [6, 4],
          pointRadius: 0,
          tension: 0,
          fill: false
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: 'index', intersect: false },
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: '#12111f', titleColor: '#9097b1',
          bodyColor: '#fff', padding: 10, cornerRadius: 8,
          callbacks: {
            label: function(ctx) {
              return ctx.dataset.label === 'Avg'
                ? ' Avg ₹' + ctx.parsed.y.toLocaleString()
                : ' ₹' + ctx.parsed.y.toLocaleString()
            }
          }
        }
      },
      scales: {
        x: {
          grid: { display: false }, border: { display: false },
          ticks: { color: '#9097b1', font: { size: 10 }, maxRotation: 45, autoSkip: true, maxTicksLimit: 12 }
        },
        y: {
          beginAtZero: true,
          grid: { color: '#f0f1f6' }, border: { display: false },
          ticks: {
            color: '#9097b1', font: { size: 11 }, maxTicksLimit: 5,
            callback: function(v) { return '₹' + v.toLocaleString() }
          }
        }
      }
    }
  })
}

/* ── Plays by Display — horizontal bar chart ── */
function initDisplaysBarChart() {
  var el = document.getElementById('displays_chart')
  if (!el) return
  if (el._chartInstance) { el._chartInstance.destroy(); el._chartInstance = null }

  var names    = JSON.parse(el.dataset.names)
  var values   = JSON.parse(el.dataset.values).map(Number)
  var billings = JSON.parse(el.dataset.billings).map(Number)

  el._chartInstance = new Chart(el, {
    type: 'bar',
    data: {
      labels: names,
      datasets: [{
        label: 'Plays',
        data: values,
        backgroundColor: names.map(function(_, i) { return PAL[i % PAL.length] }),
        borderRadius: 5,
        borderSkipped: false
      }]
    },
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: '#12111f', bodyColor: '#fff', padding: 10, cornerRadius: 8,
          callbacks: {
            afterLabel: function(ctx) {
              return '  Billing: ₹' + billings[ctx.dataIndex].toLocaleString()
            }
          }
        }
      },
      scales: {
        x: {
          beginAtZero: true,
          grid: { color: '#f0f1f6' }, border: { display: false },
          ticks: { color: '#9097b1', font: { size: 10 } }
        },
        y: {
          grid: { display: false }, border: { display: false },
          ticks: { color: '#374151', font: { size: 12, weight: '600' } }
        }
      }
    }
  })
}

/* ── DataTable ── */
function initBillingTable() {
  var table = $('#billing_table')
  if (!table.length) return
  if ($.fn.dataTable.isDataTable(table)) { table.DataTable().destroy() }
  table.DataTable({
    paging: true, pageLength: 10,
    ordering: true, order: [[0, 'desc']],
    searching: true, info: true
  })
}
